import { Create, Default, Detail, List } from "./views";


const Module = {
    name: "fringebenefitcars",
    defaultRoutePath: "/cars/fringebenefitcar",
    menuItemScope: "fleet",
    menuItemName: "fringebenefitcars",

    routes: [
        {
            path: "/cars/fringebenefitcar",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        {
            path: "create",
            Component: Create,
        },
        
    ],
    
}

export default Module;
